import { render, staticRenderFns } from "./AttendanceRequests.vue?vue&type=template&id=fd327bb6"
import script from "./AttendanceRequests.vue?vue&type=script&lang=js"
export * from "./AttendanceRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports